import { render } from "./AddNewsletter.vue?vue&type=template&id=1c3a2703"
import script from "./AddNewsletter.vue?vue&type=script&lang=js"
export * from "./AddNewsletter.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__